/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RotateElementComponent } from './rotate-element.component';
import { DxButtonModule, DxNumberBoxModule } from 'devextreme-angular';

@NgModule({
  declarations: [RotateElementComponent],
  imports: [CommonModule, DxButtonModule, DxNumberBoxModule],
  exports: [RotateElementComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RotateElementModule {}
